import React from "react";
import { FaHandshake, FaSearch, FaUserPlus } from "react-icons/fa";

const steps = [
  {
    icon: <FaUserPlus className="text-blue-600 text-3xl" />,
    title: "Sign Up",
    description: "Set up your profile with the right role, details, and collaboration goals in a few guided steps.",
  },
  {
    icon: <FaSearch className="text-blue-600 text-3xl" />,
    title: "Discover",
    description: "Explore creators, campaigns, and opportunities with clearer filters, stronger profile context, and better fit signals.",
  },
  {
    icon: <FaHandshake className="text-blue-600 text-3xl" />,
    title: "Collaborate",
    description: "Manage bids, submissions, and campaign progress in a cleaner workflow built to reduce friction.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="section-kicker mb-4">How it works</div>
          <h2 className="section-heading text-center">A simpler flow from discovery to delivery.</h2>
          <p className="section-copy mt-4">
            The experience should feel more like a modern SaaS product: faster to scan, easier to trust, and clearer at every next step.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {steps.map((step, index) => (
            <div key={index} className="elevated-card rounded-[1.75rem] p-7 text-left hover:-translate-y-1 transition-transform duration-200">
              <div className="flex items-center justify-between mb-6">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-50">
                  {step.icon}
                </div>
                <span className="text-sm font-semibold text-slate-400">0{index + 1}</span>
              </div>
              <h3 className="text-xl font-semibold mb-3 text-slate-900">{step.title}</h3>
              <p className="text-slate-600 leading-7">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
